import { HttpClient } from 'api/http-client';
import { PermissionSet } from 'api/models';
import { PermissionSet as PermissionSetEntity } from 'stores/permission-sets';

export interface FieldPermission {
  fieldId: number;
  fieldPermission: 'read' | 'write';
  private: boolean;
}

export type ProjectPermissionTypes =
  | 'READ'
  | 'WRITE'
  | 'DELETE'
  | 'CREATE'
  | 'MEMBER_UPDATE';

export enum Operation {
  Create = 'CREATE',
  Read = 'READ',
  Update = 'WRITE',
  Delete = 'DELETE',
}

export interface ProjectBasedResourcePermission {
  task: Operation[];
  document: Operation[];
  field: Operation[];
  phase: Operation[];
  space: Operation[];
  statusUpdate: Operation[];
  company?: Operation[];
  member?: Operation[];
  milestone?: Operation[];
}

export type ProjectBasedResource = keyof ProjectBasedResourcePermission;

export interface ProjectPermission extends ProjectBasedResourcePermission {
  projectId: number;
  projectName?: string | null;
  isPrivate: boolean;
  fields: Array<FieldPermission>;
  permissionSet: PermissionSet;
  project: ProjectPermissionTypes[];
}

interface ResourcePermission {
  report: Operation[];
  team: Operation[];
  template: Operation[];
  field: Operation[];
  member: Operation[];
  project: Operation[];
}

export type Resource = keyof ResourcePermission;

export interface UserPermission extends ResourcePermission {
  /* TODO:: Remove this key and user taskFields & projectFields */
  fields: Array<FieldPermission>;
  projects: Record<number, ProjectPermission>;
  projectPermissionBeanMap?: Record<number, ProjectPermission>;
  permissionSet: PermissionSet;
}

export type UserPermissionForProject = Pick<ProjectPermission, 'fields'>; // can be extended to include other props when working on rbac

class PermissionHttpClient extends HttpClient {
  public async getUserPermission(): Promise<UserPermission> {
    return this.get<UserPermission>('/permissions');
  }

  public getPermissionSets = async () =>
    this.get<PermissionSetEntity[]>('/permission-set');
}

export const PermissionAPI = new PermissionHttpClient();
